import styled from '@emotion/styled';
import { BasicFlex } from '../../../utils/Common';

import { useTheme } from '@mui/material';

const TileStyles = styled(BasicFlex)`
  align-items: stretch;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  overflow: hidden;
  width: auto;
  min-width: 30rem;
  /* max-width: ${props => props.$grow ? "none": "30rem"}; */
  background-color: white;
`

const Indicator = styled(BasicFlex)`
  background-color: ${props => props.$bg};
  min-width: 7rem;
  min-height: 7rem;
  width: auto;
  /* border-radius: 6px; */
  justify-content: center;
  align-items: center;
`

const Content = styled(BasicFlex)`
  flex-grow: 1;
  padding: 1.2rem 1.6rem;
`

const Label = styled.div`
  font-size: 1.2rem;
  text-transform: uppercase;
  font-weight: 500;
  color: ${props => props.theme.colors.lightText};
`

const Info = styled.div`
  font-size: 1.6rem;
  text-transform: capitalize;
  font-weight: 600;
  color: ${props => props.theme.colors.mildText};
`

const Tile = ({ palette = "basic", Icon, label, info, grow = false }) => {
  const theme = useTheme();
  const paletteColors = {
    ...theme.palette
  }
  let { light, main } = paletteColors[palette];
  return (
    <TileStyles>
      <Indicator $bg={light}>
        <Icon sx={{ color: main }} fontSize="large" />
      </Indicator>
      <Content dir="column" justify="space-between">
        <Label>{label}</Label>
        <Info>{info}</Info>
      </Content>
    </TileStyles>
  )
}

export default Tile;